import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    doAdd: { api: 'T1010StudentBasicService.C20101_doAdd' },
    getEdit: { api: 'T1010StudentBasicService.C20101_getEdit' },
    doEdit: { api: 'T1010StudentBasicService.C20101_doEdit' },
    doRead: { api: 'T1010StudentBasicService.doRead' },
    doDelete: { api: 'T1010StudentBasicService.doDelete' },
    doBrowse: { api: 'T1010StudentBasicService.C20101_doBrowse' },
  },
}

const module = {
  state: {
    PageConst,
    dropdownData : {
      gender: [], // 性別
      academicYear: [], // 学年
      nationalities: [], // 国籍
      classrooms: [], // 所属教室
      centers: [], // 担当センター
      advisors: [], // 担当者
      teacherGender: [], // 講師希望
      teachers: [], // 講師，
      teacherCenters: [], // 講師センター
      teacherRequestType: [], // 講師希望
      courseTypeList: [], // コース
    },

    C20101_doBrowse_init_output: {
      advisor:[]
    }
  },

  getters: {

  },

  mutations: {

  },
  actions: {
    async C20101_doBrowse_init ({ commit, state }, payload) {
      const res = await $this.$api.postData({
        data: {
          C20101_doBrowse_init:{
            api: 'T1010StudentBasicService.C20101_doBrowse_init'
          }
        }
      })
      commit('setState', {
        C20101_doBrowse_init_output: res.C20101_doBrowse_init.output
      });
    },
    async getDropdownData ({ commit,state }, payload) {
      const res = await $this.$api.postData({
        data:[
          {
            api: 'T1010StudentBasicService.C20101_getDropdownData'
          }
        ]
      })
      commit('setState', {
        dropdownData: res[0].output
      });
    }
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
